import { UpdateQuotationClientRequest } from '../../../@types/UpdateQuotation'
import { useDocumentStore } from '../../../Stores/useDocumentStore'
import { useFillDataForSimulationStore } from '../../../Stores/useFillDataForSimulationStore'
import { useGetQuotationStore } from '../../../Stores/useGetQuotationStore'
import { useQuotationMessageUpdateStore } from '../../../Stores/useQuotationMessageUpdateStore'

export const useUpdateQuotationPayload = () => {
  const { quotationUpdate } = useQuotationMessageUpdateStore()
  const { getQuotation } = useGetQuotationStore()
  const { switchAttachment } = useDocumentStore()
  const { fillDataForSimulationRequest } = useFillDataForSimulationStore()

  const updateQuotationPayload = (context: string) => {
    return {
      createdBy:
        fillDataForSimulationRequest?.agentDetailsResponse?.agentName || '',
      attachments: switchAttachment[context]
        ? quotationUpdate?.attachments?.map((file) => ({
            documentContent: file.documentContent,
            documentName: file.documentName,
            documentType: file.documentType,
          }))
        : [],
      message: {
        messageText: quotationUpdate?.message?.messageText || '',
      },
      quotationId: getQuotation?.policyQuotation?.quotationId,
      quotationStatus: getQuotation?.policyQuotation?.status || '',
    } as UpdateQuotationClientRequest
  }

  return { updateQuotationPayload }
}
